// src/components/RangeSelect.js
import React from "react";

export default function RangeSelect({ value, onChange, className }) {
  return (
    <fieldset
      className={className}
      style={{
        border: "1px solid #ccc",
        borderRadius: 6,
        padding: "6px 10px 8px",
        minWidth: 160,
      }}
    >
      <legend
        style={{
          padding: "0 6px",
          fontSize: "12px",
          fontWeight: 500,
          color: "#fff",
        }}
      >
        Select Range
      </legend>

      <select
        value={value}
        onChange={onChange}
        style={{
          width: "100%",
          border: "none",
          outline: "none",          // 🔥 no blue focus
          background: "transparent",
          color: "#fff",
          fontSize: "14px",
          cursor: "pointer",
        }}
      >
        <option value="1week" style={{ color: "#000" }}>1 Week</option>
        <option value="1month" style={{ color: "#000" }}>1 Month</option>
        <option value="3month" style={{ color: "#000" }}>3 Months</option>
        <option value="6month" style={{ color: "#000" }}>6 Months</option>
      </select>
    </fieldset>
  );
}
